import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface ClientSummary {
  id: number
  code: string
  name: string
  database_name?: string
  status?: boolean
}

interface ClientContextState {
  activeClientCode: string | null
  activeClient: ClientSummary | null
  setActiveClient: (client: ClientSummary | null) => void
  setActiveClientCode: (code: string | null) => void
  clearActiveClient: () => void
}

export const useClientContextStore = create<ClientContextState>()(
  persist(
    (set) => ({
      activeClientCode: null,
      activeClient: null,
      setActiveClient: (client) =>
        set({
          activeClient: client,
          activeClientCode: client?.code ?? null,
        }),
      setActiveClientCode: (code) =>
        set({
          activeClientCode: code,
          activeClient: null,
        }),
      clearActiveClient: () => set({ activeClientCode: null, activeClient: null }),
    }),
    {
      name: 'client-context-storage',
      partialize: (state) => ({
        activeClientCode: state.activeClientCode,
        activeClient: state.activeClient,
      }),
    }
  )
)

/** Read active client code without React (for axios interceptors). */
export function getActiveClientCodeFromStorage(): string | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = localStorage.getItem('client-context-storage')
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed?.state?.activeClientCode ?? null
  } catch {
    return null
  }
}

/** Routes that require a selected SIMA client database. */
export function routeRequiresClientContext(pathname: string): boolean {
  return (
    pathname.startsWith('/organization/stores') ||
    pathname.startsWith('/store-management/stores') ||
    pathname.startsWith('/asset-configuration') ||
    /\/organization\/clients\/[^/]+\/asset-catalog/.test(pathname)
  )
}
